import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import heart from "../../../assets/heart_icon.png";
import fullRedHeart from "../../../assets/fullRedHeart.png";
import bedroom from "../../../assets/bedroom_icon.png";
import car from "../../../assets/car_icon.png";
import shower from "../../../assets/shower_icon.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import { BACKEND_BASE_URL } from "../../../apiInstances/baseurl";
import { toast } from "react-toastify";
import axiosInstanceAuth from "../../../apiInstances/axiosInstanceAuth";
import Pagination from "../Pagination/Pagination";
import BetweenAds from "../../Adds/BetweenAds";
import { FaPlay } from "react-icons/fa";
import { AuthModal } from "../../../models/AuthModal";

const PropertyCardItem = ({
  i,
  randomColor,
  navigate,
  isAuthanticate,
  setAuthPopUp,
  isfavorite,
  SavedProperty,
}) => {
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const thumbnailImages = i?.frontPageImg?.slice(1, 4) || [];

  return (
    <>
      <style>
        {`
          .property-swiper .swiper-wrapper {
            margin: 0 !important;
            padding: 0 !important;
            width: 100% !important;
            height: 100% !important;
          }
          .property-swiper .swiper-slide {
            margin: 0 !important;
            padding: 0 !important;
            width: 100% !important;
            height: 100% !important;
          }
          .property-swiper .swiper-button-next,
          .property-swiper .swiper-button-prev {
            background: transparent !important;
            border-radius: 0 !important;
            padding: 0 !important;
            width: 40px !important;
            height: 40px !important;
            margin-top: 0 !important;
            color: white !important;
            opacity: 0.9 !important;
          }
          .property-swiper .swiper-button-next:after,
          .property-swiper .swiper-button-prev:after {
            font-size: 24px !important;
            font-weight: bold !important;
            color: white !important;
          }
          .property-swiper .swiper-button-next:hover,
          .property-swiper .swiper-button-prev:hover {
            opacity: 1 !important;
          }
        `}
      </style>
      <div
        className="flex flex-col bg-white rounded-xl w-full max-w-[640px] mx-auto mb-5 lg:mb-0"
        style={{ boxShadow: "0px 1px 4px 0px #00000029" }}
      >
        <div className="relative overflow-visible">
          <div
            style={{ backgroundColor: randomColor }}
            className="flex justify-between items-center rounded-t-xl px-4 py-2 cursor-pointer relative"
            onClick={() => navigate(`/property-house/${i?._id || i?.id}`)}
          >
            <div className="flex items-center">
              <LazyLoadImage
                src={i?.lead_agent?.agencyLogo}
                alt=""
                srcSet={i?.lead_agent?.agencyLogo}
                loading="lazy"
                effect="blur"
                className="h-6 sm:h-8 md:h-10 w-auto"
              />
            </div>

            <div className="flex items-center text-white mr-24">
              <span className="text-xs md:text-sm font-medium">
                {i?.lead_agent?.name || ""}
              </span>
            </div>
          </div>

          {i?.lead_agent?.profileImg && (
            <div className="absolute right-4 -bottom-10 z-30">
              <LazyLoadImage
                src={i?.lead_agent?.profileImg}
                alt=""
                srcSet={i?.lead_agent?.profileImg}
                loading="lazy"
                effect="blur"
                className="h-16 w-16 md:h-20 md:w-20 rounded-full object-cover shadow-lg"
              />
            </div>
          )}
        </div>

        <div className="relative w-full overflow-visible">
          <div
            className="relative w-full overflow-hidden"
            style={{ aspectRatio: "16/10" }}
          >
            <Swiper
              spaceBetween={0}
              slidesPerView={1}
              modules={[Navigation]}
              navigation={true}
              onSwiper={setSwiperInstance}
              onSlideChange={(swiper) =>
                setActiveImageIndex(swiper.activeIndex)
              }
              className="property-swiper w-full h-full"
              style={{
                margin: 0,
                padding: 0,
                width: "100%",
                height: "100%",
              }}
            >
              {i?.frontPageImg?.map((e, inx) => (
                <SwiperSlide
                  key={inx}
                  className="!w-full !h-full !m-0"
                  style={{
                    width: "100%",
                    height: "100%",
                    margin: 0,
                    padding: 0,
                  }}
                >
                  <div
                    className="w-full h-full overflow-hidden"
                    style={{
                      width: "100%",
                      height: "100%",
                      margin: 0,
                      padding: 0,
                    }}
                  >
                    <img
                      src={e}
                      alt="img"
                      loading="lazy"
                      onClick={() =>
                        navigate(`/property-house/${i?._id || i?.id}`)
                      }
                      className="cursor-pointer"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                        margin: 0,
                        padding: 0,
                      }}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {i?.videoUrl && (
              <div className="absolute bottom-4 right-4 bg-white rounded-lg p-2 cursor-pointer z-20">
                <FaPlay className="text-black text-sm" />
              </div>
            )}
          </div>

          {thumbnailImages.length > 0 && (
            <div className="grid grid-cols-3 gap-1 p-1 bg-gray-50">
              {thumbnailImages.map((thumb, thumbIndex) => (
                <div
                  key={thumbIndex}
                  className={`cursor-pointer overflow-hidden ${
                    activeImageIndex === thumbIndex + 1
                      ? "ring-2 ring-blue-500"
                      : ""
                  }`}
                  style={{ aspectRatio: "16/10" }}
                  onClick={() => {
                    if (swiperInstance) {
                      swiperInstance.slideTo(thumbIndex + 1);
                    }
                  }}
                >
                  <img
                    src={thumb}
                    alt={`thumbnail ${thumbIndex + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="px-4 py-4">
          <div className="flex justify-between items-start">
            {/* <div className="font-semibold text-[#3D3B40] text-lg md:text-xl flex-1">
              {i?.price && i?.price_display_checked === 'show_actual_price'
                ? "$" + String(i?.price).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                : i?.price_display || "Expression of Interest"}
            </div> */}
            <div className="font-normal text-[#3D3B40] text-sm md:text-base mb-2">
              {i?.street_address_number} {i?.street_address_name}
            </div>
            <div
              className="cursor-pointer ml-2"
              onClick={(e) => {
                e.stopPropagation();
                if (!isAuthanticate) {
                  setAuthPopUp(true);
                } else {
                  isfavorite(i);
                }
              }}
            >
              {i.favourite ? (
                <img
                  src={fullRedHeart}
                  alt="heart"
                  className="w-5 h-5 cursor-pointer"
                />
              ) : (
                <svg
                  className="w-5 h-5 text-gray-400 cursor-pointer"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                  />
                </svg>
              )}
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-2 text-[#3D3B40]">
            {i?.bedroomCount && (
              <div className="flex items-center">
                <img src={bedroom} alt="bedroom" className="w-4 h-4 mr-1" />
                <span className="text-sm md:text-base">{i?.bedroomCount}</span>
              </div>
            )}
            {i?.showerCount && (
              <div className="flex items-center">
                <img src={shower} alt="bathroom" className="w-4 h-4 mr-1" />
                <span className="text-sm md:text-base">{i?.showerCount}</span>
              </div>
            )}
            {i?.carport_spaces && (
              <div className="flex items-center">
                <img src={car} alt="car" className="w-4 h-4 mr-1" />
                <span className="text-sm md:text-base">
                  {i?.carport_spaces}
                </span>
              </div>
            )}
            {(i?.property_type || i?.acreageCount) && (
              <div className="flex items-center">
                <span className="mx-1 text-gray-400">·</span>
                <span className="text-sm md:text-base">
                  {i?.property_type || i?.acreageCount}
                </span>
              </div>
            )}
          </div>

          {i?.price && i?.price_display_checked === "show_actual_price" && (
            <div className="flex items-center gap-1.5 mt-2">
              <div className="inline-flex items-center bg-gray-100 rounded-full px-2.5 py-1">
                <span className="text-[#3D3B40] text-xs font-normal">
                  Indicative price:{" "}
                  <span className="font-semibold">
                    ${String(i?.price).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </span>
                </span>
              </div>
              <svg
                className="w-3.5 h-3.5 text-gray-500 cursor-pointer"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const PropertySoldCard = ({
  PropertyData,
  setPropertyData,
  style,
  adsList,
}) => {
  const navigate = useNavigate();
  let PageSize = 5;
  const isAuthanticate = localStorage.getItem("Token");
  const [AuthPopUp, setAuthPopUp] = useState(false);
  const [SavedProperty, setSavedProperty] = useState(
    localStorage.getItem("Saved")?.split(","),
  );

  const [currentPage, setCurrentPage] = React.useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Assuming you have an array of data called `myData`
  const startIndex = (currentPage - 1) * PageSize;
  const endIndex = startIndex + PageSize;
  const currentData = PropertyData.slice(startIndex, endIndex);
  useEffect(() => {
    setPropertyData((prevData) => {
      return prevData.map((x) => ({
        ...x,
        favourite: SavedProperty?.includes(x.id),
      }));
    });
  }, [SavedProperty]);

  const isfavorite = async (i) => {
    await axiosInstanceAuth
      .post("addToFavorites", {
        id: i?.id,
      })
      .then((res) => {
        const mydata = res?.data?.data;
        if (res?.data?.status) {
          NoRepeatConvertIntoFav(i);
          toast.success(res?.data?.message);
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        //console.log("err --->", err);
      });
  };

  const NoRepeatConvertIntoFav = (i) => {
    const index = SavedProperty?.findIndex((x) => x == i?.id);

    const newArray =
      index === -1
        ? [...SavedProperty, i?.id]
        : [...SavedProperty.slice(0, index), ...SavedProperty.slice(index + 1)];

    setSavedProperty(newArray);
  };

  const colors = ["#492665", "#1E3A8A", "#065F46", "#9D174D", "#7C3AED"];

  return (
    <>
      <div className={`grid place-items-center grid-cols-1 gap-5 ${style} `}>
        {PropertyData?.length > 0 ? (
          currentData?.map((i, index) => {
            const randomColor = colors[index % colors.length];

            return (
              <React.Fragment key={i.id}>
                <PropertyCardItem
                  i={i}
                  randomColor={randomColor}
                  navigate={navigate}
                  isAuthanticate={isAuthanticate}
                  setAuthPopUp={setAuthPopUp}
                  isfavorite={isfavorite}
                  SavedProperty={SavedProperty}
                />
                {index % 2 !== 0 &&
                  adsList &&
                  adsList[Math.floor(index / 2)] && (
                    <BetweenAds detail={adsList[Math.floor(index / 2)]} />
                  )}
              </React.Fragment>
            );
          })
        ) : (
          <>
            <h1 className="flex justify-center text-5xl font-semibold  text-[#737373] my-24">
              No data Found
            </h1>
          </>
        )}
      </div>
      {/* <<----- Paginationp ----->> */}
      <div className="flex w-full max-w-[640px] mx-auto justify-center">
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={PropertyData?.length}
          pageSize={PageSize}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>

      {/* <<----- Auth Pop Up ----->> */}
      {AuthPopUp ? (
        <AuthModal open={AuthPopUp} onClose={() => setAuthPopUp(false)} />
      ) : null}
    </>
  );
};

export default PropertySoldCard;
